export const fitView = (func, zoom = 1.2) =>
  func({ maxZoom: zoom, minZoom: zoom });

export const onVisibleChange = (v) => {
  const _el = document.querySelector('.main-project-container');
  if (_el) {
    if (v) {
      _el.style.overflowY = 'hidden';
    } else {
      _el.style.overflowY = 'auto';
    }
  }
};
